module.exports = __webpack_public_path__ + "img/logo-04.a13c3515.svg";